module.exports = __webpack_public_path__ + "img/ava.28013b13.svg";